import React from 'react'
import styled from 'styled-components'

const TemperatureValue = ({ value }: { value: number | string }) => {
  const formattedValue = value !== '' ? parseFloat(String(value)).toFixed(1) : value
  return (
    <S.Container>
      <S.ThermometerIcon />

      <S.Value>{formattedValue} °F</S.Value>
    </S.Container>
  )
}

export default TemperatureValue

const S = {
  Container: styled.div`
    display: flex;
    margin-bottom: 15px;
  `,
  ThermometerIcon: styled.span`
    width: 22px;
    height: 22px;
    margin-right: 5px;
    background-image: url('/img/thermometer.svg');
    background-size: contain;
    background-repeat: no-repeat;
  `,
  Value: styled.span`
  `
}
